import { Component, OnInit, OnDestroy, Renderer2, Inject, DOCUMENT } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import { UserDashboardService } from '../user-dashboard.service';
import {Router} from '@angular/router';


@Component({
    selector: 'app-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss'],
    standalone: false
})
export class ChatbotComponent implements OnInit {
  labels;
  labelsSub: Subscription;

  private scriptElement: HTMLScriptElement;
  private linkElement: HTMLLinkElement;

  users: User[]
  constructor(private languageService: UserLanguageService,
              private router: Router,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {

    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })

    // Add link tag
    this.linkElement = this.renderer.createElement('link');
    this.linkElement.rel = 'stylesheet';
    this.linkElement.href = 'https://mu.rgz.gov.rs/rgz-platforma-chatbot/styles.css';
    this.renderer.appendChild(this.document.head, this.linkElement);

    // Add script tag
    this.scriptElement = this.renderer.createElement('script');
    this.scriptElement.src = 'https://mu.rgz.gov.rs/rgz-platforma-chatbot/main.js';
    this.scriptElement.defer = true;
    this.scriptElement.type = 'module';
    this.renderer.appendChild(this.document.head, this.scriptElement);

    // Add script tag
    this.scriptElement = this.renderer.createElement('script');
    this.scriptElement.src = 'https://mu.rgz.gov.rs/rgz-platforma-chatbot/polyfills.js';
    this.scriptElement.defer = true;
    this.renderer.appendChild(this.document.head, this.scriptElement);

  }

  ngOnDestroy(): void {
    // Unsubscribe from labels
    if (this.labelsSub) {
      this.labelsSub.unsubscribe();
    }

    // Remove script tag
    if (this.scriptElement) {
      this.renderer.removeChild(this.document.head, this.scriptElement);
    }

    // Remove link tag
    if (this.linkElement) {
      this.renderer.removeChild(this.document.head, this.linkElement);
    }
  }

}
